'use client'
import { toast } from 'sonner';

type CopyToClipboardFunction = (
  text: string,
  message?: string,
) => Promise<boolean>;

/**
 * Hook to provide clipboard copy functionality with toast notifications
 * @returns A function that copies text to the clipboard and shows a toast notification
 */
export const useCopyToClipboard = (): CopyToClipboardFunction => {
  const copyToClipboard: CopyToClipboardFunction = async (
    text,
    message = 'Copied to clipboard',
  ) => {
    if (!text) return false;

    try {
      await navigator.clipboard.writeText(text);
      toast.success(message);
      return true;
    } catch (err) {
      console.error('Could not copy text: ', err);
      toast.error('Failed to copy to clipboard');
      return false;
    }
  };

  return copyToClipboard;
};

